(function () {
  "use strict";

  angular.module("tikonApp").controller("CouponsList", CouponsList);

  CouponsList.$inject = ["$timeout", "$state", "$rootScope"];

  function CouponsList($timeout, $state, $rootScope) {
    function initCouponsList() {
      var CouponsListElement = document.getElementById("coupons-list");
      CouponsListElement.addEventListener("prevPageBtn", function () {
        $state.go("supplierPanel-v2.setting");
      });
      CouponsListElement.addEventListener("backToPrevVersion", function () {
        $state.go("supplierPanel-v2.couponList");
      });
    }
    $timeout(initCouponsList, 50);
  }
})();
